import axios from "axios";
import { getAuthHeader } from '../utils';

export const recruiterProfileDetails = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/profile`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const editProfileFormData = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejzsh/company/profile-formdata`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const updateCompanyProfile = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/company/profile`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const recruiterKycDetails = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruiter-kyc-details`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};
export const  updateCompanyPicture = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/upload-company-pic`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};

export const uploadEmplogo = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruit-upload-company-logo`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};

export const uploadEmpHeader = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruit-upload-company-header`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};

export const uploadAddressProof = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/kyc-upload-address-proof`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};
export const uploadPan = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/kyc-upload-pan`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};
export const uploadGstin = (file) => {
    const url = `${process.env.REACT_APP_BASE_URL}/kyc-upload-gstin`;
    return axios.post(url, file, getAuthHeader()).then((res) => {
        return res.data
    })
};

export const updateKyc = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruit-kyc-update`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const countryList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-country-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const stateList = (COUNTRY_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-state-list?COUNTRY_ID=${COUNTRY_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const cityList = (STATE_ID) => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-city-list?STATE_ID=${STATE_ID}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const entityTypeList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-entity-type-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const addressProofType = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-addressproof-type-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const getMasterSkillsList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/skills-list`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        if (res.status) {
            return res.data;
        }
    })
}
export const RoleList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruit-role-list`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        if (res.status) {
            return res.data;
        }
    })
}

export const futureHiring = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/future-hiring`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        if (res.status) {
            return res.data;
        }
    })
}

export const futureHiringList = (body) => {
    const url = `${process.env.REACT_APP_BASE_URL}/future-hiring-list?page=${body.page}`;
    return axios.put(url, body, getAuthHeader()).then((res) => {
        if (res.status) {
            return res.data;
        }
    })
}

export const futureHiringStatusById = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/archive-future-hiring-status-by-id`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};